
import { RevButton } from '@ds/components/Button'
import { RevRating } from '@ds/components/Rating'
import { IconQuality } from '@ds/icons/IconQuality'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { TRACKING_ZONE } from '@internal-reviews/components/Page/constants'
import RateFilter from '@internal-reviews/components/RateFilter'
import ReviewsLegalModal from '@internal-reviews/components/ReviewsLegalModal'
import ReviewsList from '@internal-reviews/components/ReviewsList'
import {
  REVIEWS_TYPES,
  getRateDistributionRequest,
} from '@internal-reviews/helpers'
import { logReviewsError } from '@reviews/helpers'
import { trackClick, trackReviewBlockImpression } from '@tracking/events'

import translations from './ReviewsBlock.translations'

export default {
  components: {
    IconQuality,
    RateFilter,
    RevRating,
    RevButton,
    ReviewsLegalModal,
    ReviewsList,
  },
  props: {
    averageRate: {
      type: Number,
      required: true,
    },
    reviewsCount: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rateDistribution: [],
    }
  },
  computed: {
    translations: () => translations,
    shouldDisplayCta() {
      return this.reviewsCount > 1
    },
    reviewTrackingInfo() {
      return {
        ...this.trackingInfo,
        averageRate: this.averageRate,
        pageType: this.$route.name,
      }
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  async mounted() {
    this.watchReviewInViewport()

    try {
      const request = getRateDistributionRequest({
        type: REVIEWS_TYPES.PRODUCT,
        params: { id: this.productId },
      })

      const { payload: rateDistribution } = await this.$store.dispatch(
        'http/request',
        request,
      )

      this.rateDistribution = rateDistribution.statsInfo
    } catch (err) {
      logReviewsError({ tags: ['ProductPage'], err })
    }
  },
  methods: {
    watchReviewInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        trackReviewBlockImpression(this.reviewTrackingInfo)
      })
    },
    displayDivider(index) {
      return index < this.reviews.length - 1
    },
    trackReviews() {
      trackClick({
        zone: TRACKING_ZONE,
        name: 'see_all_reviews',
        pageType: this.$route.name,
      })
    },
  },
}
